import React from "react";
import styled from "styled-components";

import theme from "../../styles/theme";

const StyledSvg = styled.svg`
  width: 100%;
  display: block;
  ${() => theme.media.tabletUp`
    display: none;
  `};
`;

const StretchLogoMobile = () => {
  return (
    <div>
      <StyledSvg
        width="340"
        height="654"
        viewBox="0 0 340 654"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M340 554.161C340 550.972 337.676 548.389 334.809 548.389H319.878C317.011 548.389 314.687 545.805 314.687 542.618V228.509C314.687 225.32 317.012 222.736 319.879 222.737L334.808 222.742C337.674 222.743 340 220.159 340 216.97V5.77178C340 2.58411 337.676 0 334.809 0C334.809 0 152.555 0 150.686 0C148.818 0 146.172 2.9228 146.172 2.9228L103.16 68.7779L64.2754 3.09193C63.3791 1.19098 61.6082 0 59.678 0H5.19135C2.32454 0 0.000529248 2.5841 0.000511055 5.77174L2.33534e-05 39.7627C5.16029e-06 42.9504 2.32403 45.5345 5.19087 45.5345H17.9092C20.7761 45.5345 23.1 48.1186 23.1 51.3063V154.656C23.1 157.844 20.7761 160.428 17.9092 160.428C17.9092 160.428 8.05767 160.428 5.19084 160.428C2.32402 160.428 -5.29547e-06 163.012 0 166.2L0.000534407 648.228C0.000539703 651.416 2.32456 654 5.19138 654H53.9206C56.7874 654 59.1114 651.416 59.1114 648.228V612.687C59.1114 609.5 56.7874 606.915 53.9206 606.915H44.7068C41.8399 606.915 39.516 604.331 39.516 601.144V537.642L72.4415 580.15C73.8655 583.286 77.8789 583.329 79.3574 580.224L115.829 533.628V601.144C115.829 604.331 113.505 606.915 110.639 606.915H96.8015C93.9347 606.915 91.6106 609.5 91.6106 612.687V648.228C91.6106 651.416 93.9347 654 96.8015 654H334.809C337.676 654 340 651.416 340 648.228V554.161Z"
          fill="#C8F169"
        />
      </StyledSvg>
    </div>
  );
};

export default StretchLogoMobile;
